import { Component, OnInit } from '@angular/core';
import { Installations } from 'src/app/model/installations/installations.model';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';
import { UserService } from 'src/app/services/http/user/user.service';

@Component({
  selector: 'app-installations-list',
  templateUrl: './installations-list.component.html',
  styleUrls: ['./installations-list.component.scss']
})
export class InstallationsListComponent implements OnInit {

  constructor(private service : InstallationsService, private userService:UserService) { }

  public installations! : Installations;
  public restricted! : boolean;
  
  ngOnInit(): void {

    this.restricted = localStorage.getItem('restricted')=='true'; // != undefined;

    this.service.getInstallations()
      .subscribe( (installations) => {
          console.log(installations);
          this.installations = installations;
          
    });


  }

}
